import { Container, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { z } from "zod";
import HttpClient from "../../api/HttpClient";
import NavBar from "../../component/NavBar";
import { useLoading } from "../../constant/LoadingContext";
import DocumentTemplate from "./DocTemplate";
import DocumentLists from "./DocumentLists";

const docSignatureSchema = z.object({
  signature: z.string(),
  signatureDate: z.date(),
});

const docSignFormSchema = z.object({
  id: z.string(),
  docSignature: z.record(docSignatureSchema),
});
type DocSignForm = z.infer<typeof docSignFormSchema>;

const SignedDocument = () => {
  const classes = useStyles();
  const [docLists, setDocLists] = useState([]);
  const [showStatus, setShowStatus] = useState<"list" | "document">("list");
  const [docContent, setDocContent] = useState(null);
  const [allSigned, setAllSigned] = useState(false);
  const { setLoading } = useLoading();
  const location = useLocation();
  const navigate = useNavigate();
  const _searchValue =
    location?.state?.searchValue || localStorage.getItem("searchValue");

  const useFormReturn = useForm<DocSignForm>({
    defaultValues: {
      id: _searchValue,
      docSignature: {},
    },
  });

  const { register, handleSubmit, formState, setValue } = useFormReturn;
  const docSignatureWatch = useWatch({
    name: "docSignature",
    control: useFormReturn.control,
  });

  useEffect(() => {
    if (docLists.length > 0) {
      let isAllSigned = true;
      docLists.forEach((doc) => {
        if (!docSignatureWatch[doc?.documentName]?.signature) {
          isAllSigned = false;
        }
      });
      setAllSigned(isAllSigned);
    }
  }, [docSignatureWatch, docLists]);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  useEffect(() => {
    const FetchDocLists = async () => {
      HttpClient().FetchDocListsApi(
        {
          searchValue: _searchValue,
          userDataFilter: user?.data?.userDataFilter,
        },
        (data) => {
          setDocLists(data?.data);
          setLoading(false);
        },
        (error) => {
          alert(error);
          setLoading(false);
        }
      );
    };
    if (_searchValue !== undefined || _searchValue !== null) {
      setLoading(true);
      FetchDocLists();
    }
  }, []);

  return (
    <Container className={classes.container}>
      <NavBar
        isBack={true}
        goBack={() => {
          if (showStatus === "document") {
            setShowStatus("list");
          } else {
            navigate(-1);
          }
        }}
        isNeedPW={ false }
      />
      <div style={{ backgroundColor: "#F0EFF6", minHeight: "90%" }}>
        {docLists.length > 0 && showStatus === "list" && (
          <DocumentLists
            docLists={docLists}
            setDocContent={setDocContent}
            setShowStatus={setShowStatus}
            allSigned={allSigned}
            docSignatureWatch={docSignatureWatch}
            readonly={true}
          />
        )}
        {docContent && showStatus === "document" && (
          <DocumentTemplate
            docContent={docContent}
            brand={docContent?.brand}
            signature={docSignatureWatch[docContent?.documentName]?.signature || docLists.find(doc => doc.documentName === docContent?.documentName)?.signature}
            signatureDate={docSignatureWatch[docContent?.documentName]?.signatureDate || docLists.find(doc => doc.documentName === docContent?.documentName)?.signatureDate}
            readonly={true}
          />
        )}
      </div>
    </Container>
  );
};

export default SignedDocument;

const useStyles = makeStyles((theme) => ({
  container: {
    height: "100vh",
    borderRadius: "10rem",
  },
}));
